import { SidebarMenuItem } from "./model";

export const SIDEBAR_CONF: SidebarMenuItem[] = [
  {
    label: "Home",
    value: "dashboard",
    path: "/dashboard",
    allow: ['super_admin'],
    subMenus: [],
  },
  {
    label: "Products",
    value: "products",
    path: "/products",
    allow: ['super_admin'],
    subMenus: [],
  },
  {
    label: "Inventory",
    value: "inventory",
    path: "",
    allow: ['super_admin', 'admin'],
    subMenus: [
      {
        label: "Stock Quantity",
        value: "stock_quantity",
        path: "/inventory/stock-quantity",
        allow: ['super_admin', 'admin'],
      },
      {
        label: "Stock Transfer",
        value: "stock_transfer",
        path: "/inventory/stock-transfer",
        allow: ['super_admin', 'admin'],
      },
      {
        label: "Set Product Number",
        value: "products",
        path: "/inventory/set-product-number",
        allow: ['super_admin'],
      },
    ],
  },
  // {
  //   label: "Orders",
  //   value: "orders",
  //   path: "",
  //   subMenus: [],
  // },
  // {
  //   label: "Trade",
  //   value: "trade",
  //   path: "",
  //   subMenus: [],
  // },
  {
    label: "Notifications",
    value: "notification",
    path: "/notification",
    allow: ['super_admin'],
    subMenus: [],
  },
  {
    label: "Users",
    value: "users",
    path: "/users",
    allow: ['super_admin'],
    subMenus: [],
  },
  {
    label: "Settings",
    value: "settings",
    path: "",
    allow: ['super_admin'],
    subMenus: [
      {
        label: "News",
        value: "news",
        path: "settings/news",
        allow: ['super_admin'],
      },
      {
        label: "Warehouse",
        value: "warehouse",
        path: "settings/warehouse",
        allow: ['super_admin'],
      },
    ],
  },
];
